// Copyright (C) Digital Jetty Konrad Gadzinowski - All Rights Reserved

import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import { Modal } from "../../submodules/rapdv/client/elements/Bootstrap"

export class PanelTeamInvite implements ClientPage {
  private removeModal: Modal | null = null

  getPageId = (): string => "team-invite-panel"

  execute = (): void => {
    this.setupRemoveModal()
  }

  onPageClose = (): void => {}

  private setupRemoveModal = (): void => {
    const modalEl = document.getElementById("team-remove-member-modal")
    if (!modalEl) return
    this.removeModal = new Modal(modalEl)

    document.querySelectorAll<HTMLElement>("[data-action='remove-team-member']").forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.dataset.id ?? ""
        const email = btn.dataset.email ?? ""

        const idInput = modalEl.querySelector<HTMLInputElement>("input[name='id']")
        if (idInput) idInput.value = id

        const textEl = document.getElementById("team-remove-member-text")
        if (textEl) {
          const prefix = textEl.dataset.confirmPrefix ?? "Are you sure you want to remove"
          const suffix = textEl.dataset.confirmSuffix ?? "from your team?"
          textEl.textContent = `${prefix} ${email} ${suffix}`
        }

        this.removeModal?.show()
      })
    })
  }
}
